const SEGMENT_DRAW_CMD = { 2: 'lineTo', 4: 'quadraticCurveTo', 6: 'bezierCurveTo' };

export function scalePath(points, size = [1, 1]) {
  return points.map((p) => p.map((v, i) => (v * size[i % 2]) / 100));
}

export function drawPath(points, context, w, h) {
  let path = w && h ? scalePath(points, [w, h]) : points;
  path.forEach((p) => context[SEGMENT_DRAW_CMD[p.length]](...p));
}
